import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import { Toast } from 'antd-mobile';
import bridge from '@/config/JSbridge';
import get from 'lodash/get';

// import Star from './imgs/star@2x.png';
import DeclaimImg from './imgs/declaim@2x.png';
import MainBg from './imgs/main-bg@2x.png';
import BtnCancel from './imgs/btn-cancel@2x.png';
import ExitConfirm from './imgs/exit-confirm@2x.png'

import UserCardImg from './imgs/user-card@2x.png';
import Arrow from './imgs/arrow@2x.png';
import ToolBG from './imgs/tool-bg@2x.png'
import Badge from './imgs/badge@2x.png';
import ViewbackTitle from './imgs/viewback-title@2x.png';
import ExistTitle from './imgs/exist-title@2x.png';
import PreMonthTitle from './imgs/pre-month@2x.png';
import SaveTitle from './imgs/save-title@2x.png';
import SaveShare from './imgs/save-share@2x.png';
import LogoImg from './imgs/logo@2x.png';

import NotUse from './imgs/not-use@2x.png';
import UseBack from './imgs/use-back@2x.png';
import ConfirmBtn from './imgs/confirm-btn@2x.png';
import ProgressImg from './imgs/progress@2x.png';

import { getMonthStockInfo, selectStock, getToolInfo, useTool  } from './api';
import { activityShare, isStorm, getStockStr, shareWechart, sleep, handleUploadTrace } from './stock';
import bwmodel from '@/config/bwmodel'
import ModalTips from './components/modal-tips';
import CommonModal from "./components/common-modal";

let isSelecting = false;

const Page2 = ({ step, mode, next, exit, uniqueCode = '', activityInfo, archiveInfo, isReadArchive }) => {
  const [month, setMonth] = useState(isReadArchive ? Number(`${archiveInfo.archiveMonth}`.slice(4, 6)) : 1);
  const [data, setData] = useState({});

  const accountRef = useRef();
  const monthRef = useRef(1);

  const [toolInfo, setToolInfo] = useState([]);

  const [selectIndex, setSelectIndex] = useState(null);

  const monthStr = `2023${month > 9 ? month : '0' + month}`;

  const modalRef = useRef();
  const commonModalRef = useRef();

  const rollbackCount = get(toolInfo, '[0].count') || 0;
  const prevAnalysisCount = get(toolInfo, '[1].count') || 0;

  const stepRef = useRef();
  stepRef.current = step;

  useEffect(() => {}, [
    bridge.addRegisterHandler([{
      name: 'viewWillAppear',
      callback: () => {
        if (stepRef.current === 2) {
          setSelectIndex(null);
          isSelecting = false;
        }
      }
    }])
  ], []);

  useLayoutEffect(() => {
    if (accountRef.current) {
      const parentWidth = accountRef.current.clientWidth;
      const childrenWidth = accountRef.current.children[0].clientWidth + accountRef.current.children[1].clientWidth;
      if (childrenWidth > parentWidth) {
        accountRef.current.style.fontSize = '12px';
      }
    }
  }, [data])
  
  useEffect(() => {
    getMonthStockInfo({month: monthStr, uniqueCode}).then(res => {
      monthRef.current = month;
      setData(res);
    });

    handleUploadTrace(`month-${month}`, 'click')
  }, [month]);

  useEffect(() => {
    getToolInfo({uniqueCode}).then(res => {
      setToolInfo(res);
    })
  }, [])

  const buyStock = (params) => {
    selectStock(params).then(res => {
      setTimeout(() => {
        isSelecting = false
        if (month === 12) {
          handleFinishSelect();
          return;
        }
        setSelectIndex(null)
        setMonth(month + 1);
      }, 1000)
    }).catch(() => {
      setTimeout(() => {
        isSelecting = false
      }, 1000)
    })
  }

  const handleFinishSelect = () => {
    next();
  }

  const handleSelect = async (item, index) => {
    if (isSelecting) {
      return;
    }
    setSelectIndex(index);
    isSelecting = true;

    const stockName = item.stockName;

    if (mode === 'trading') {
      commonModalRef.current.show(
        <ExistContainer>
          <div className="buy-content">
            <span>正在前往</span>
            <span className="buy-value">{monthRef.current}月</span>
            <span>的</span>
            <span className="buy-value">{stockName}</span>
            <span>实际操作，本次操作收益将作为最终收益。</span>
          </div>
          <div className="buy-progress-wrap">
            <div className="buy-progress">
              <div className="buy-mask progress-animate">
                <div className="buy-mask-bar"></div>
              </div>
            </div>
          </div>
          <div className="progress-text">
            数据载入中…
          </div>
        </ExistContainer>
      );

      await sleep(1800);
      commonModalRef.current.close();

      bridge.callHandler(
        'nativeEvent',
        {
          event: 'realSimulationEvent',
          params: {
            month: monthRef.current,
            stockId: item.stockCode,
            year: 2023,
            stockName: item.stockName
          }
        },
        (res) => {
          const response = JSON.parse(res)
         
          if (response.code === 0) {
            Toast.info('结算成功');
            buyStock({
              month: `2023${monthRef.current > 9 ? monthRef.current : '0' + monthRef.current}`,
              stockCode: item.stockCode,
              incomeRatio: Number(Number(response.params.profit / 100).toFixed(4))
            });
          }
        }
      )
      return;
    }

    buyStock({ month: monthStr, stockCode: item.stockCode, uniqueCode });
  }

  const handleUseBack = () => {
    isStorm && shareWechart();
    useTool({ props: 'rollback', month: monthStr }).then(res => {
      Toast.info(`已成功回到${month - 1}月份`)
      setMonth(month - 1);

      commonModalRef.current.close();
      getToolInfo({uniqueCode}).then(res => {
        setToolInfo(res);
      });
    });

    /** **/
    handleUploadTrace('share', 'click');
  };

  const handleBackPreMonth = () => {
    if (month === 1) {
      modalRef.current.show({
        content: '「重回上月」无法在1月使用',
        isConfirm: true,
        title: <img alt="" src={PreMonthTitle} style={{ width: 94, height: 23 }} />
      });
      return;
    }

    if (rollbackCount === 0) {
      modalRef.current.show({
        content: '「重回上月」道具已达使用上限。',
        isConfirm: true,
        title: <img alt="" src={PreMonthTitle} style={{ width: 94, height: 23 }} />
      });
      return;
    }

    if (isStorm) {
      commonModalRef.current.show(
        <ExistContainer>
          <div className="flex-center">
            <span className="text-title">重回{monthRef.current - 1}月份</span>
          </div>
          <div className="exist-content">
            使用「重回上月」道具，可再回到{monthRef.current - 1}月份重新选择买入的股票。
          </div>
          <div className="btns-row flex-center">
            <img onClick={() => handleUseBack()} src={UseBack} alt="" style={{ width: 172, height: 46 }}/>
          </div>
          <div className="btns-row flex-center">
            <img onClick={() => commonModalRef.current.close()} src={NotUse} alt="" style={{ width: 172, height: 46 }}/>
          </div>
        </ExistContainer>
      );
      return;
    }

    useTool({ uniqueCode, props: 'rollback', month: monthStr }).then(res => {
      Toast.info(`已成功回到${month - 1}月份`)
      setMonth(month - 1);

      getToolInfo({uniqueCode}).then(res => {
        setToolInfo(res);
      })
    });

    /** **/
    handleUploadTrace('back', 'click');
  }

  const handleShareSave = () => {
    useTool({ uniqueCode, props: 'archiveAdd', month: monthStr }).then(res => {
      Toast.info('存档成功');
      commonModalRef.current.close();

      getToolInfo({uniqueCode}).then(res => {
        setToolInfo(res);
      })
    })
    shareWechart();
    
    /** **/
    handleUploadTrace('share', 'click');

    /** **/
    handleUploadTrace('save', 'click');
  }

  const handleSave = () => {
    if (!isStorm) {
      modalRef.current.show({
        content: '「游戏存档」功能仅限市值风云APP使用',
        isConfirm: true,
      });

      return;
    }

    if (month === 1) {
      modalRef.current.show({
        title: <img src={SaveTitle} alt="" style={{ width: 94, height: 23 }} />,
        content: '「游戏存档」无法在1月使用',
        isConfirm: true,
      });
      return;
    }

    commonModalRef.current.show(
      <ExistContainer>
        <div className="flex-center">
          <img alt="" src={SaveTitle} style={{ width: 98, height: 23 }} />
        </div>
        <div className="exist-content">
          是否将重生存档在2023年{monthRef.current}月？
        </div>
        <div className="btns-wrap">
          <img onClick={() => commonModalRef.current.close()} src={BtnCancel} alt="" style={{ width: 114, height: 46 }}/>
          <img onClick={handleShareSave} src={SaveShare} alt="" style={{ width: 142, height: 46 }}/>
        </div>
      </ExistContainer>
    )
  }

  const handleViewback = () => {
    if (month === 1) {
      modalRef.current.show({
        content: '「回看解析」无法在1月使用',
        isConfirm: true,
        title: <img alt="" src={ViewbackTitle} style={{ width: 96, height: 23 }} />
      });
      return;
    }
    if (!isStorm && prevAnalysisCount === 0) {
      modalRef.current.show({
        content: '「回看解析」功能使用超过限制，可前往市值风云体验完整版',
      });
      return;
    }
    useTool({ uniqueCode, props: 'prevAnalysis', month: monthStr }).then(res => {
      getToolInfo({uniqueCode}).then(res => {
        setToolInfo(res);
      });

      commonModalRef.current.show(
        <ExistContainer>
          <div className="flex-center">
            <span className="text-title">{res.frameTitle}</span>
          </div>
          <div className="exist-content">
            {res.frameContent}
          </div>
          <div className="analisis-mark">声明：解析内容部分来源于网络，不构成投资建议</div>
          <div className="btns-row flex-center">
            <img onClick={() => commonModalRef.current.close()} src={ConfirmBtn} alt="" style={{ width: 114, height: 46 }}/>
          </div>
        </ExistContainer>
      );
    });

    /** **/
    handleUploadTrace('analysis', 'click');
  }

  const handleExist = () => {
    if (month === 1) {
      modalRef.current.show({
        content: '「销户退出」无法在1月使用',
        isConfirm: true,
        title: <img alt="" src={ExistTitle} style={{ width: 96, height: 23 }} />
      });
      return;
    }

    /** **/
    handleUploadTrace(`stock_page-exit-month${month}`, 'click');

    commonModalRef.current.show(
      <ExistContainer>
        <div className="flex-center">
          <img alt="" src={ExistTitle} style={{ width: 96, height: 23 }} />
        </div>
        <div className="exist-content">
          市值风云提醒您：复利模式，收益率越往后越恐怖，您确定要立即退出吗（前往查看结果）？
        </div>
        <div className="btns-wrap">
          <img onClick={() => commonModalRef.current.close()} src={BtnCancel} alt="" style={{ width: 114, height: 46 }}/>
          <img onClick={() => exit()} src={ExitConfirm} alt="" style={{ width: 113, height: 46 }}/>
        </div>
      </ExistContainer>
      
    )
  }

  return (
    <Container>
      {
        isStorm &&
        <Header
          title="重生之股神模拟器"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
        />
      }
      
      <div className={`page-body ${!isStorm ? 'hide-header' : ''}`}>
        <div className="page-content">
          <img src={MainBg} className='main-bg' alt=''/>
          <img src={DeclaimImg} alt='' className="declaim-img" />
          <img src={DeclaimImg} alt='' className="declaim-img-footer" />
          
          <div className="stock-content">
    
            <div className="user-card">
              <img alt="" src={UserCardImg} className="user-card-bg" />
              <div className="user-card-content">
                <div className="user-card-top">
                  <div className="user-avatar">
                    <img src={activityInfo.user.avatar || LogoImg} alt='' className="avatar"/>
                    <div className="user-name">
                      <div className="user-role">
                        <img src={Arrow} alt='' className="badge" />
                        <div className="user-role-text">{activityInfo.user.nickname || '市值风云'}</div>
                      </div>
                      <div className="month-progress">{monthRef.current}/12</div>
                    </div>
                  </div>
                </div>

                <div ref={accountRef} className="account user-login-account">
                  <div className="assets-total">账户资产:{data.assets}</div>
                  <div className="profit-total">总收益:{data.incomeRatio > 0 ? '+' : ''}{data.incomeRatio ? Number(data.incomeRatio * 100).toFixed(2) + '%' : '0%'}</div>
                </div>
              </div>
            </div>

            <div className='stock-desc scroll-container'>
              <div dangerouslySetInnerHTML={{__html: getStockStr(data.incomeDetail)}}></div>
            </div>

            <div className='monitor-buy-text'>{month === 1 ? '债台高筑，看着A股账户中仅剩的10万块，你决定满仓买入这只股票：' : `${month}月份，你决定满仓买入这只股票：`}</div>
            <div className="stock-wrap">
              {
                Array.isArray(data.stocks) && data.stocks.map((item, index) => {
                  return (
                    <div
                      onClick={() => handleSelect(item, index)}
                      className={`stock-item ${`stock-enter${index}`} ${index === selectIndex ? 'select-stock-item' : ''}`}
                      key={`${item.stockCode}${index}${monthRef.current}`}
                    >
                      {item.stockName}
                      {index === selectIndex && <img src={Arrow} className={`select-stock-img`} alt="" />}
                    </div>
                  )
                })
              }
            </div>

            <div className="tool-list">
              <div className="tool-item" onClick={handleBackPreMonth}>
                重回上月
                <div className="tool-count">{rollbackCount}</div>
              </div>
              <div className="tool-item" onClick={handleViewback}>
                回看解析
                {!isStorm ? <div className="tool-count">{prevAnalysisCount}</div> : null}
              </div>
              <div className="tool-item" onClick={handleSave}>
                游戏存档
              </div>
              <div className="tool-item" onClick={handleExist}>
                销户退出
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalTips ref={modalRef}/>
      <CommonModal ref={commonModalRef}/>
    </Container>
  );
}

export default React.memo(Page2);

const ExistContainer = styled.div`
  @keyframes progress {
    0% { width: 100%; }
    100% { width: 0%; }
  }
  .progress-animate {
    animation-name: progress;
    animation-timing-function: ease-in;
    animation-duration: 1.6s;
    animation-fill-mode: forwards;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .exist-content {
    padding: 0 28px;
    margin-top: 12px;
    font-size: 17px;
    font-weight: 600;
    color: #000000;
    line-height: 23px;
  }
  .btns-wrap {
    display: flex;
    padding: 0 27px;
    margin-top: 9px;
    justify-content: space-between;
  }

  .analisis-mark {
    font-size: 12px;
    font-weight: 400;
    color: #B1211C;
    line-height: 26px;
    margin-bottom: 10px;
    padding: 0 28px;
  }
  .text-title {
    font-size: 17px;
    font-weight: 400;
    color: #000000;
    line-height: 26px;
    font-weight: bold;
  }
  .buy-content {
    padding: 16px 33px 24px;
    font-size: 17px;
    font-weight: 500;
    color: #000000;
    line-height: 26px;
    .buy-value {
      color: #B1211C;
    }
  }
  .buy-progress-wrap {
    padding: 0 30px;
  }
  .buy-progress {
    height: 34px;
    background-image: url(${ProgressImg});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .buy-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      padding: 3px 2px 3px 3px;
      box-sizing: border-box;
      .buy-mask-bar {
        width: 100%;
        height: 100%;
        background: #b1211c;
      }
    }
  }
  .progress-text {
    font-size: 17px;
    font-weight: 500;
    color: #000000;
    line-height: 26px;
    text-align: center;
    margin-top: 9px;
  }
`;

const Container = styled.div`
@keyframes enter0 {
  0% { left: -300px; }
  100% { left: 0; }
}
@keyframes enter1 {
  0% { left: -500px; }
  100% { left: 0; }
}
@keyframes enter2 {
  0% { left: -700px; }
  100% { left: 0; }
}
@keyframes enter3 {
  0% { left: -900px; }
  100% { left: 0; }
}
.stock-item {
  animation-timing-function: ease-out;
  animation-duration: 0.8s;
}
.stock-enter0 {
  animation-name: enter0;
  
}
.stock-enter1 {
  animation-name: enter1;
}
.stock-enter2 {
  animation-name: enter2;
}
.stock-enter3 {
  animation-name: enter3;
}
.stock-content {
  margin: 9.5px 8px 0;
  background: #3B2B2C;
  padding-bottom: 13.5px;
  border-radius: 14px;
  height: calc(100% - 90px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.user-card {
  width: 100%;
  height: 102px;
  position: relative;
  .user-card-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.user-card-top {
  display: flex;
  justify-content: space-between;
  padding-top: 15px;
}
.user-card-content {
  padding: 0 22px;
  position: relative;
  z-index: 2;
  .user-info {
    padding-top: 18.5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .user-role {
    display: flex;
    align-items: center;
    overflow: hidden;
    .badge {
      width: 12.5px;
      height: 20px;
      margin-right: 9.5px;
    }
    .user-role-text {
      font-size: 19px;
      font-weight: 400;
      color: #EAC5A9;
      line-height: 38px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .coin-img-wrap {
    width: 72.5px;
    height: 14px;
    position: relative;
    top: -12px;
    flex-shrink: 0;
    .coin-img {
      width: 100%;
      height: 100%;
    }
  }
  .user-login-exit {
    top: 3px;
  }
}
.account {
  margin-top: 14.5px;
  font-size: 13.5px;
  font-weight: 400;
  color: #FFA112;
  display: flex;
  align-items: center;
  .assets-total {
    padding-right: 14px;
    white-space: nowrap;
  }
  .profit-total {
    white-space: nowrap;
  }
}
.user-login-account {
  margin-top: 11px;
}

.stock-desc {
  overflow-y: scroll;
  flex: 1;
  margin: 13.5px 19px 22.5px 22px;
  font-size: 16px;
  font-weight: 300;
  color: #EAC5A9;
  line-height: 20px;
}
.monitor-buy-text {
  font-size: 16.5px;
  font-weight: 600;
  line-height: 23px;
  color: #EAC5A9;
  padding: 0 19px 12px 22px;
}

.stock-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 12px;
  .stock-item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #FFE4D0;
    width: 305px;
    height: 40px;
    border: 1.5px solid #EC7E24;
    border-radius: 20px;
    box-sizing: border-box;
    margin-bottom: 10.5px;
    position: relative;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  .select-stock-item {
    background: #EC7E24;
    position: relative;
  }

  .select-stock-img {
    width: 13.5px;
    height: 23px;
    position: absolute;
    left: -20px;
    top: 7px;
  }
}
.tool-list {
  font-size: 23px;
  font-weight: 500;
  color: #EC7E24;
  margin-top: 13px;
  line-height: 23px;
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
  .tool-item {
    width: 77px;
    height: 41px;
    background-image: url(${ToolBG});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: 12px;
    font-weight: 600;
    color: #FFE4D0;
    line-height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .tool-count {
    background-image: url(${Badge});
    width: 23px;
    height: 23px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: -4px;
    top: -6px;

    font-size: 16px;
    font-weight: 500;
    color: #FFE4D0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.user-avatar {
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  .avatar {
    width: 47px;
    height: 47px;
    border-radius: 12px;
  }
  .user-name {
    overflow: hidden;
    width: 100%;
    padding-left: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .month-progress {
    font-size: 23px;
    font-weight: 500;
    color: #EC7E24;
    line-height: 25px;
  }
}
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/page2.js